export const CUSTOM_BRANDING = 'custom-branding';
export const CUSTOM_VIDEO_THUMBS = 'custom-video-thumbs';
export const CUSTOM_VIDEO_ACCESS = 'custom-video-access';
export const END_OF_VIDEO_CTA = 'end-of-video-cta';
export const EXTERNAL_BETA = 'external-beta';
export const LOOM_PRO = 'loom-pro';
export const BILLING = 'billing';
export const HD_RECORDING = 'hd-recording';
export const HLS_RECORDING_INFRA_CAPABILITY = 'hls-recording-infra';
export const LOOM_TEAM = 'loom-team';
export const MAC_APP = 'mac-app';
export const WINDOWS_APP = 'windows-app';
export const DESKTOP_SCREEN_CROP = 'desktop-screen-crop';
